import { createFileRoute } from "@tanstack/react-router";
import SpravatoVsKetamine from "@/pages/SpravatoVsKetamine";
export const Route = createFileRoute("/spravato-vs-ketamine")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SPRAVATO® vs Ketamine | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "SPRAVATO® vs ketamine for depression: compare FDA-cleared esketamine to off-label IV ketamine. Both available at Neuro Wellness in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "SPRAVATO® vs Ketamine | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "SPRAVATO® vs ketamine for depression: compare FDA-cleared esketamine to off-label IV ketamine. Both available at Neuro Wellness in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/spravato-vs-ketamine",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/spravato-vs-ketamine",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SpravatoVsKetamine />;
}
